// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── BreakdownTable — Premium Data Table ─── */
.BreakdownTable_breakdown__5MQti {
  background: var(--bg-2, #fff);
  border-radius: 14px;
  padding: 28px 28px 24px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);
}
.BreakdownTable_breakdown__header__f50-b {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}
.BreakdownTable_breakdown__title__StEwi {
  font-family: "Lora", "Georgia", serif;
  font-size: 22px;
  font-weight: 700;
  color: var(--text-1, #1a1a1a);
  line-height: 1.25;
}
.BreakdownTable_breakdown__subtitle__lLSFZ {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #c8a95e;
  margin-top: 4px;
}
.BreakdownTable_breakdown__scroll-hint__5UEa8 {
  font-size: 12px;
  font-style: italic;
  color: var(--grey-text, #999);
  white-space: nowrap;
  padding-top: 6px;
}

/* ─── Table Wrapper ─── */
.BreakdownTable_table-scroll__3Byer {
  overflow-x: auto;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  /* Custom scrollbar */
}
.BreakdownTable_table-scroll__3Byer::-webkit-scrollbar {
  height: 6px;
}
.BreakdownTable_table-scroll__3Byer::-webkit-scrollbar-track {
  background: transparent;
}
.BreakdownTable_table-scroll__3Byer::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.12);
  border-radius: 3px;
}

/* Body: one flat surface (thead keeps its own header look) */
.BreakdownTable_table__XDvv6 {
  width: 100%;
  border-collapse: collapse;
  min-width: 700px;
  table-layout: fixed;
}
.BreakdownTable_table__XDvv6 thead th {
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
.BreakdownTable_table__XDvv6 thead th:last-child {
  border-right: none;
}
.BreakdownTable_table__XDvv6 tbody td {
  background: #f8fafc;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
.BreakdownTable_table__XDvv6 tbody td:last-child {
  border-right: none;
}

/* ─── Header: Corner Cell ─── */
.BreakdownTable_header-keyword-corner__LNASR {
  position: sticky;
  left: 0;
  z-index: 4;
  background: var(--background-color-1, #f7f8fa);
  border-bottom: 2px solid rgba(0, 0, 0, 0.08);
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  padding: 14px 18px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--grey-text, #666);
  text-align: left;
  min-width: 120px;
  max-width: 150px;
  vertical-align: middle;
}

/* ─── Header: Institution Group ─── */
.BreakdownTable_header-inst__UIR-g {
  text-align: center;
  padding: 12px 10px;
  background: var(--background-color-1, #f7f8fa);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.BreakdownTable_header-inst__inner__B3UIi {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.BreakdownTable_header-inst__name__s4Rhf {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--accent-color, #0f3460);
  line-height: 1.3;
  word-break: break-word;
  max-width: 160px;
}

/* ─── Header: Sub-columns ─── */
.BreakdownTable_header-sub__hH8o- {
  padding: 8px 10px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--grey-text, #888);
  text-align: center;
  background: var(--background-color-1, #f7f8fa);
  border-bottom: 2px solid rgba(0, 0, 0, 0.08);
  white-space: nowrap;
  min-width: 72px;
}

/* ─── Logos ─── */
.BreakdownTable_logo-img__r8tEc {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  object-fit: contain;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.BreakdownTable_logo-fallback__vZAch {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: var(--accent-color-light, #e8eef5);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: var(--accent-color, #0f3460);
}

/* ─── Body Rows ─── */
.BreakdownTable_body-row__kQlS3 {
  transition: background 0.15s;
}
.BreakdownTable_body-row__kQlS3:hover .BreakdownTable_kw-cell__K4kUf, .BreakdownTable_body-row__kQlS3:hover .BreakdownTable_metric-cell__i6nKA, .BreakdownTable_body-row__kQlS3:hover .BreakdownTable_data-cell__dh52\\+ {
  background: #eef2f7;
}

/* ─── Keyword Cell (sticky) ─── */
.BreakdownTable_kw-cell__K4kUf {
  position: sticky;
  left: 0;
  z-index: 2;
  padding: 14px 18px;
  font-size: 13px;
  font-weight: 600;
  color: var(--accent-color, #0f3460);
  text-transform: capitalize;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  white-space: nowrap;
  min-width: 120px;
  max-width: 150px;
  transition: background 0.15s;
}

/* ─── Entity row cell (entity-major layout) ─── */
.BreakdownTable_entity-cell__WwwhQ {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.BreakdownTable_entity-cell__name__FV3IY {
  font-size: 13px;
  font-weight: 600;
  color: var(--accent-color, #0f3460);
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

.BreakdownTable_metric-cell__i6nKA {
  padding: 12px 12px;
  font-size: 12px;
  font-weight: 600;
  color: var(--grey-text, #666);
  letter-spacing: 0.2px;
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  /* Full metric label wraps onto multiple lines instead of truncating. */
  white-space: normal;
  overflow-wrap: break-word;
  line-height: 1.35;
}

/* ─── Data Cell ─── */
.BreakdownTable_data-cell__dh52\\+ {
  padding: 12px 12px;
  font-size: 13px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: var(--text-1, #333);
  text-align: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  transition: background 0.15s;
}

/* ─── Responsive ─── */
@media only screen and (max-width: 768px) {
  .BreakdownTable_breakdown__5MQti {
    padding: 20px 16px;
    border-left-width: 2px;
  }
  .BreakdownTable_breakdown__header__f50-b {
    flex-direction: column;
    gap: 8px;
  }
  .BreakdownTable_breakdown__title__StEwi {
    font-size: 18px;
  }
  .BreakdownTable_breakdown__scroll-hint__5UEa8 {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/BreakdownTable/BreakdownTable.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,gDAAA;AAEA;EACE,6BAAA;EACA,mBAAA;EACA,uBAAA;EACA,wEAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AACJ;AAEE;EACE,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,iBAAA;AAAJ;AAGE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;AADJ;AAIE;EACE,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;AAFJ;;AAMA,0BAAA;AACA;EACE,gBAAA;EACA,qCAAA;EACA,kBAAA;EAEA,qBAAA;AAJF;AAKE;EACE,WAAA;AAHJ;AAME;EACE,uBAAA;AAJJ;AAOE;EACE,+BAAA;EACA,kBAAA;AALJ;;AASA,6DAAA;AAGA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AARF;AAUE;EACE,0CAAA;AARJ;AAUI;EACE,kBAAA;AARN;AAYE;EACE,mBAjBiB;EAkBjB,0CAAA;AAVJ;AAYI;EACE,kBAAA;AAVN;;AAeA,gCAAA;AACA;EACE,gBAAA;EACA,OAAA;EACA,UAAA;EACA,8CAAA;EACA,4CAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AAZF;;AAeA,sCAAA;AACA;EACE,kBAAA;EACA,kBAAA;EACA,8CAAA;EACA,4CAAA;AAZF;AAcE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAZJ;AAeE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mCAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AAbJ;;AAiBA,gCAAA;AACA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,6BAAA;EACA,kBAAA;EACA,8CAAA;EACA,4CAAA;EACA,mBAAA;EACA,eAAA;AAdF;;AAiBA,kBAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qCAAA;AAdF;;AAiBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;AAdF;;AAiBA,sBAAA;AACA;EACE,4BAAA;AAdF;AAgBE;EAGE,mBAAA;AAhBJ;;AAoBA,kCAAA;AACA;EACE,gBAAA;EACA,OAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,0BAAA;EACA,4CAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AAjBF;;AAoBA,kDAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAjBF;AAmBE;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAjBJ;;AAqBA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;EACA,4CAAA;EACA,uEAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;AAlBF;;AAqBA,sBAAA;AACA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,0BAAA;EACA,kBAAA;EACA,4CAAA;EACA,4BAAA;AAlBF;;AAqBA,uBAAA;AACA;EACE;IACE,kBAAA;IACA,sBAAA;EAlBF;EAoBE;IACE,sBAAA;IACA,QAAA;EAlBJ;EAqBE;IACE,eAAA;EAnBJ;EAsBE;IACE,aAAA;EApBJ;AACF","sourcesContent":["/* ─── BreakdownTable — Premium Data Table ─── */\n\n.breakdown {\n  background: var(--bg-2, #fff);\n  border-radius: 14px;\n  padding: 28px 28px 24px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n  }\n\n  &__title {\n    font-family: \"Lora\", \"Georgia\", serif;\n    font-size: 22px;\n    font-weight: 700;\n    color: var(--text-1, #1a1a1a);\n    line-height: 1.25;\n  }\n\n  &__subtitle {\n    font-size: 12px;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    color: #c8a95e;\n    margin-top: 4px;\n  }\n\n  &__scroll-hint {\n    font-size: 12px;\n    font-style: italic;\n    color: var(--grey-text, #999);\n    white-space: nowrap;\n    padding-top: 6px;\n  }\n}\n\n/* ─── Table Wrapper ─── */\n.table-scroll {\n  overflow-x: auto;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 8px;\n\n  /* Custom scrollbar */\n  &::-webkit-scrollbar {\n    height: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.12);\n    border-radius: 3px;\n  }\n}\n\n/* Body: one flat surface (thead keeps its own header look) */\n$breakdown-tbody-bg: #f8fafc;\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 700px;\n  table-layout: fixed;\n\n  thead th {\n    border-right: 1px solid rgba(0, 0, 0, 0.1);\n\n    &:last-child {\n      border-right: none;\n    }\n  }\n\n  tbody td {\n    background: $breakdown-tbody-bg;\n    border-right: 1px solid rgba(0, 0, 0, 0.1);\n\n    &:last-child {\n      border-right: none;\n    }\n  }\n}\n\n/* ─── Header: Corner Cell ─── */\n.header-keyword-corner {\n  position: sticky;\n  left: 0;\n  z-index: 4;\n  background: var(--background-color-1, #f7f8fa);\n  border-bottom: 2px solid rgba(0, 0, 0, 0.08);\n  border-right: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 14px 18px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: var(--grey-text, #666);\n  text-align: left;\n  min-width: 120px;\n  max-width: 150px;\n  vertical-align: middle;\n}\n\n/* ─── Header: Institution Group ─── */\n.header-inst {\n  text-align: center;\n  padding: 12px 10px;\n  background: var(--background-color-1, #f7f8fa);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n\n  &__inner {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 6px;\n  }\n\n  &__name {\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.6px;\n    color: var(--accent-color, #0f3460);\n    line-height: 1.3;\n    word-break: break-word;\n    max-width: 160px;\n  }\n}\n\n/* ─── Header: Sub-columns ─── */\n.header-sub {\n  padding: 8px 10px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--grey-text, #888);\n  text-align: center;\n  background: var(--background-color-1, #f7f8fa);\n  border-bottom: 2px solid rgba(0, 0, 0, 0.08);\n  white-space: nowrap;\n  min-width: 72px;\n}\n\n/* ─── Logos ─── */\n.logo-img {\n  width: 36px;\n  height: 36px;\n  border-radius: 6px;\n  object-fit: contain;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.logo-fallback {\n  width: 36px;\n  height: 36px;\n  border-radius: 6px;\n  background: var(--accent-color-light, #e8eef5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--accent-color, #0f3460);\n}\n\n/* ─── Body Rows ─── */\n.body-row {\n  transition: background 0.15s;\n\n  &:hover .kw-cell,\n  &:hover .metric-cell,\n  &:hover .data-cell {\n    background: #eef2f7;\n  }\n}\n\n/* ─── Keyword Cell (sticky) ─── */\n.kw-cell {\n  position: sticky;\n  left: 0;\n  z-index: 2;\n  padding: 14px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--accent-color, #0f3460);\n  text-transform: capitalize;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  white-space: nowrap;\n  min-width: 120px;\n  max-width: 150px;\n  transition: background 0.15s;\n}\n\n/* ─── Entity row cell (entity-major layout) ─── */\n.entity-cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n\n  &__name {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--accent-color, #0f3460);\n    line-height: 1.3;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 220px;\n  }\n}\n\n.metric-cell {\n  padding: 12px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--grey-text, #666);\n  letter-spacing: 0.2px;\n  text-align: left;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  /* Full metric label wraps onto multiple lines instead of truncating. */\n  white-space: normal;\n  overflow-wrap: break-word;\n  line-height: 1.35;\n}\n\n/* ─── Data Cell ─── */\n.data-cell {\n  padding: 12px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n  color: var(--text-1, #333);\n  text-align: center;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  transition: background 0.15s;\n}\n\n/* ─── Responsive ─── */\n@media only screen and (max-width: 768px) {\n  .breakdown {\n    padding: 20px 16px;\n    border-left-width: 2px;\n\n    &__header {\n      flex-direction: column;\n      gap: 8px;\n    }\n\n    &__title {\n      font-size: 18px;\n    }\n\n    &__scroll-hint {\n      display: none;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakdown": `BreakdownTable_breakdown__5MQti`,
	"breakdown__header": `BreakdownTable_breakdown__header__f50-b`,
	"breakdown__title": `BreakdownTable_breakdown__title__StEwi`,
	"breakdown__subtitle": `BreakdownTable_breakdown__subtitle__lLSFZ`,
	"breakdown__scroll-hint": `BreakdownTable_breakdown__scroll-hint__5UEa8`,
	"table-scroll": `BreakdownTable_table-scroll__3Byer`,
	"table": `BreakdownTable_table__XDvv6`,
	"header-keyword-corner": `BreakdownTable_header-keyword-corner__LNASR`,
	"header-inst": `BreakdownTable_header-inst__UIR-g`,
	"header-inst__inner": `BreakdownTable_header-inst__inner__B3UIi`,
	"header-inst__name": `BreakdownTable_header-inst__name__s4Rhf`,
	"header-sub": `BreakdownTable_header-sub__hH8o-`,
	"logo-img": `BreakdownTable_logo-img__r8tEc`,
	"logo-fallback": `BreakdownTable_logo-fallback__vZAch`,
	"body-row": `BreakdownTable_body-row__kQlS3`,
	"kw-cell": `BreakdownTable_kw-cell__K4kUf`,
	"metric-cell": `BreakdownTable_metric-cell__i6nKA`,
	"data-cell": `BreakdownTable_data-cell__dh52+`,
	"entity-cell": `BreakdownTable_entity-cell__WwwhQ`,
	"entity-cell__name": `BreakdownTable_entity-cell__name__FV3IY`
};
export default ___CSS_LOADER_EXPORT___;
